import packageJson from '../package.json';

const clearCache = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }

      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(cache => caches.delete(cache)));
      }

      console.log('🧹 Cache e service workers limpos.');
    } catch (error) {
      console.error('Erro ao limpar cache:', error);
    }
  }
};

export const clearCacheIfNewVersion = async () => {
  const currentVersion = packageJson.version;
  const storedVersion = localStorage.getItem('app_version');
  console.log(`🚀 Versão atual: ${currentVersion}`);

  if (!storedVersion) {
    localStorage.setItem('app_version', currentVersion);
    return;
  }

  if (storedVersion !== currentVersion) {
    console.log(`🔄 Nova versão detectada (${storedVersion} → ${currentVersion})`);
    await clearCache();
    localStorage.setItem('app_version', currentVersion);
    window.location.reload(true);
  }
};
